export * from '../models/AgentCreateDTO.js';
export * from '../models/AgentDetailsDTO.js';
export * from '../models/AgentItemForNameDTO.js';
export * from '../models/AgentQueryDTO.js';
export * from '../models/AgentQueryWhere.js';
export * from '../models/AgentSummaryDTO.js';
export * from '../models/AgentSummaryStatsDTO.js';
export * from '../models/AgentUpdateDTO.js';
export * from '../models/AiApiKeyCreateDTO.js';
export * from '../models/AiApiKeyInfoDTO.js';
export * from '../models/AiModelInfoDTO.js';
export * from '../models/ApiTokenInfoDTO.js';
export * from '../models/AppMetaDTO.js';
export * from '../models/CharacterBackendDTO.js';
export * from '../models/CharacterBackendDetailsDTO.js';
export * from '../models/CharacterCreateDTO.js';
export * from '../models/CharacterDetailsDTO.js';
export * from '../models/CharacterItemForNameDTO.js';
export * from '../models/CharacterQueryDTO.js';
export * from '../models/CharacterQueryWhere.js';
export * from '../models/CharacterSummaryDTO.js';
export * from '../models/CharacterSummaryStatsDTO.js';
export * from '../models/CharacterUpdateDTO.js';
export * from '../models/ChatContentDTO.js';
export * from '../models/ChatContextDTO.js';
export * from '../models/ChatCreateDTO.js';
export * from '../models/ChatMessageDTO.js';
export * from '../models/ChatMessageRecordDTO.js';
export * from '../models/ChatPromptContentDTO.js';
export * from '../models/ChatSessionDTO.js';
export * from '../models/ChatToolCallDTO.js';
export * from '../models/ChatUpdateDTO.js';
export * from '../models/HotTagDTO.js';
export * from '../models/InteractiveStatsDTO.js';
export * from '../models/LlmResultDTO.js';
export * from '../models/MemoryUsageDTO.js';
export * from '../models/PluginCreateDTO.js';
export * from '../models/PluginDetailsDTO.js';
export * from '../models/PluginQueryDTO.js';
export * from '../models/PluginQueryWhere.js';
export * from '../models/PluginSummaryDTO.js';
export * from '../models/PluginSummaryStatsDTO.js';
export * from '../models/PluginUpdateDTO.js';
export * from '../models/PromptAiParamDTO.js';
export * from '../models/PromptCreateDTO.js';
export * from '../models/PromptDetailsDTO.js';
export * from '../models/PromptItemForNameDTO.js';
export * from '../models/PromptQueryDTO.js';
export * from '../models/PromptQueryWhere.js';
export * from '../models/PromptRefDTO.js';
export * from '../models/PromptSummaryDTO.js';
export * from '../models/PromptSummaryStatsDTO.js';
export * from '../models/PromptTaskDTO.js';
export * from '../models/PromptTaskDetailsDTO.js';
export * from '../models/PromptTemplateDTO.js';
export * from '../models/PromptUpdateDTO.js';
export * from '../models/RagTaskDTO.js';
export * from '../models/RagTaskDetailsDTO.js';
export * from '../models/SseEmitter.js';
export * from '../models/TokenUsageDTO.js';
export * from '../models/UserBasicInfoDTO.js';
export * from '../models/UserDetailsDTO.js';
export * from '../models/UserFullDetailsDTO.js';

import { AgentCreateDTO } from '../models/AgentCreateDTO.js';
import { AgentDetailsDTO } from '../models/AgentDetailsDTO.js';
import { AgentItemForNameDTO } from '../models/AgentItemForNameDTO.js';
import { AgentQueryDTO } from '../models/AgentQueryDTO.js';
import { AgentQueryWhere } from '../models/AgentQueryWhere.js';
import { AgentSummaryDTO } from '../models/AgentSummaryDTO.js';
import { AgentSummaryStatsDTO } from '../models/AgentSummaryStatsDTO.js';
import { AgentUpdateDTO } from '../models/AgentUpdateDTO.js';
import { AiApiKeyCreateDTO } from '../models/AiApiKeyCreateDTO.js';
import { AiApiKeyInfoDTO } from '../models/AiApiKeyInfoDTO.js';
import { AiModelInfoDTO } from '../models/AiModelInfoDTO.js';
import { ApiTokenInfoDTO } from '../models/ApiTokenInfoDTO.js';
import { AppMetaDTO } from '../models/AppMetaDTO.js';
import { CharacterBackendDTO } from '../models/CharacterBackendDTO.js';
import { CharacterBackendDetailsDTO } from '../models/CharacterBackendDetailsDTO.js';
import { CharacterCreateDTO } from '../models/CharacterCreateDTO.js';
import { CharacterDetailsDTO } from '../models/CharacterDetailsDTO.js';
import { CharacterItemForNameDTO } from '../models/CharacterItemForNameDTO.js';
import { CharacterQueryDTO } from '../models/CharacterQueryDTO.js';
import { CharacterQueryWhere } from '../models/CharacterQueryWhere.js';
import { CharacterSummaryDTO } from '../models/CharacterSummaryDTO.js';
import { CharacterSummaryStatsDTO } from '../models/CharacterSummaryStatsDTO.js';
import { CharacterUpdateDTO } from '../models/CharacterUpdateDTO.js';
import { ChatContentDTO } from '../models/ChatContentDTO.js';
import { ChatContextDTO } from '../models/ChatContextDTO.js';
import { ChatCreateDTO } from '../models/ChatCreateDTO.js';
import { ChatMessageDTO } from '../models/ChatMessageDTO.js';
import { ChatMessageRecordDTO } from '../models/ChatMessageRecordDTO.js';
import { ChatPromptContentDTO } from '../models/ChatPromptContentDTO.js';
import { ChatSessionDTO } from '../models/ChatSessionDTO.js';
import { ChatToolCallDTO } from '../models/ChatToolCallDTO.js';
import { ChatUpdateDTO } from '../models/ChatUpdateDTO.js';
import { HotTagDTO } from '../models/HotTagDTO.js';
import { InteractiveStatsDTO } from '../models/InteractiveStatsDTO.js';
import { LlmResultDTO } from '../models/LlmResultDTO.js';
import { MemoryUsageDTO } from '../models/MemoryUsageDTO.js';
import { PluginCreateDTO } from '../models/PluginCreateDTO.js';
import { PluginDetailsDTO } from '../models/PluginDetailsDTO.js';
import { PluginQueryDTO } from '../models/PluginQueryDTO.js';
import { PluginQueryWhere } from '../models/PluginQueryWhere.js';
import { PluginSummaryDTO } from '../models/PluginSummaryDTO.js';
import { PluginSummaryStatsDTO } from '../models/PluginSummaryStatsDTO.js';
import { PluginUpdateDTO } from '../models/PluginUpdateDTO.js';
import { PromptAiParamDTO } from '../models/PromptAiParamDTO.js';
import { PromptCreateDTO } from '../models/PromptCreateDTO.js';
import { PromptDetailsDTO } from '../models/PromptDetailsDTO.js';
import { PromptItemForNameDTO } from '../models/PromptItemForNameDTO.js';
import { PromptQueryDTO } from '../models/PromptQueryDTO.js';
import { PromptQueryWhere } from '../models/PromptQueryWhere.js';
import { PromptRefDTO } from '../models/PromptRefDTO.js';
import { PromptSummaryDTO } from '../models/PromptSummaryDTO.js';
import { PromptSummaryStatsDTO } from '../models/PromptSummaryStatsDTO.js';
import { PromptTaskDTO } from '../models/PromptTaskDTO.js';
import { PromptTaskDetailsDTO } from '../models/PromptTaskDetailsDTO.js';
import { PromptTemplateDTO } from '../models/PromptTemplateDTO.js';
import { PromptUpdateDTO } from '../models/PromptUpdateDTO.js';
import { RagTaskDTO } from '../models/RagTaskDTO.js';
import { RagTaskDetailsDTO } from '../models/RagTaskDetailsDTO.js';
import { SseEmitter } from '../models/SseEmitter.js';
import { TokenUsageDTO } from '../models/TokenUsageDTO.js';
import { UserBasicInfoDTO } from '../models/UserBasicInfoDTO.js';
import { UserDetailsDTO } from '../models/UserDetailsDTO.js';
import { UserFullDetailsDTO } from '../models/UserFullDetailsDTO.js';

/* tslint:disable:no-unused-variable */
let primitives = [
                    "string",
                    "boolean",
                    "double",
                    "integer",
                    "long",
                    "float",
                    "number",
                    "any"
                 ];

let enumsMap: Set<string> = new Set<string>([
]);

let typeMap: {[index: string]: any} = {
    "AgentCreateDTO": AgentCreateDTO,
    "AgentDetailsDTO": AgentDetailsDTO,
    "AgentItemForNameDTO": AgentItemForNameDTO,
    "AgentQueryDTO": AgentQueryDTO,
    "AgentQueryWhere": AgentQueryWhere,
    "AgentSummaryDTO": AgentSummaryDTO,
    "AgentSummaryStatsDTO": AgentSummaryStatsDTO,
    "AgentUpdateDTO": AgentUpdateDTO,
    "AiApiKeyCreateDTO": AiApiKeyCreateDTO,
    "AiApiKeyInfoDTO": AiApiKeyInfoDTO,
    "AiModelInfoDTO": AiModelInfoDTO,
    "ApiTokenInfoDTO": ApiTokenInfoDTO,
    "AppMetaDTO": AppMetaDTO,
    "CharacterBackendDTO": CharacterBackendDTO,
    "CharacterBackendDetailsDTO": CharacterBackendDetailsDTO,
    "CharacterCreateDTO": CharacterCreateDTO,
    "CharacterDetailsDTO": CharacterDetailsDTO,
    "CharacterItemForNameDTO": CharacterItemForNameDTO,
    "CharacterQueryDTO": CharacterQueryDTO,
    "CharacterQueryWhere": CharacterQueryWhere,
    "CharacterSummaryDTO": CharacterSummaryDTO,
    "CharacterSummaryStatsDTO": CharacterSummaryStatsDTO,
    "CharacterUpdateDTO": CharacterUpdateDTO,
    "ChatContentDTO": ChatContentDTO,
    "ChatContextDTO": ChatContextDTO,
    "ChatCreateDTO": ChatCreateDTO,
    "ChatMessageDTO": ChatMessageDTO,
    "ChatMessageRecordDTO": ChatMessageRecordDTO,
    "ChatPromptContentDTO": ChatPromptContentDTO,
    "ChatSessionDTO": ChatSessionDTO,
    "ChatToolCallDTO": ChatToolCallDTO,
    "ChatUpdateDTO": ChatUpdateDTO,
    "HotTagDTO": HotTagDTO,
    "InteractiveStatsDTO": InteractiveStatsDTO,
    "LlmResultDTO": LlmResultDTO,
    "MemoryUsageDTO": MemoryUsageDTO,
    "PluginCreateDTO": PluginCreateDTO,
    "PluginDetailsDTO": PluginDetailsDTO,
    "PluginQueryDTO": PluginQueryDTO,
    "PluginQueryWhere": PluginQueryWhere,
    "PluginSummaryDTO": PluginSummaryDTO,
    "PluginSummaryStatsDTO": PluginSummaryStatsDTO,
    "PluginUpdateDTO": PluginUpdateDTO,
    "PromptAiParamDTO": PromptAiParamDTO,
    "PromptCreateDTO": PromptCreateDTO,
    "PromptDetailsDTO": PromptDetailsDTO,
    "PromptItemForNameDTO": PromptItemForNameDTO,
    "PromptQueryDTO": PromptQueryDTO,
    "PromptQueryWhere": PromptQueryWhere,
    "PromptRefDTO": PromptRefDTO,
    "PromptSummaryDTO": PromptSummaryDTO,
    "PromptSummaryStatsDTO": PromptSummaryStatsDTO,
    "PromptTaskDTO": PromptTaskDTO,
    "PromptTaskDetailsDTO": PromptTaskDetailsDTO,
    "PromptTemplateDTO": PromptTemplateDTO,
    "PromptUpdateDTO": PromptUpdateDTO,
    "RagTaskDTO": RagTaskDTO,
    "RagTaskDetailsDTO": RagTaskDetailsDTO,
    "SseEmitter": SseEmitter,
    "TokenUsageDTO": TokenUsageDTO,
    "UserBasicInfoDTO": UserBasicInfoDTO,
    "UserDetailsDTO": UserDetailsDTO,
    "UserFullDetailsDTO": UserFullDetailsDTO,
}

type MimeTypeDescriptor = {
    type: string;
    subtype: string;
    subtypeTokens: string[];
};

/**
 * Every mime-type consists of a type, subtype, and optional parameters.
 * The subtype can be composite, including information about the content format.
 * For example: `application/json-patch+json`, `application/merge-patch+json`.
 *
 * This helper transforms a string mime-type into an internal representation.
 * This simplifies the implementation of predicates that in turn define common rules for parsing or stringifying
 * the payload.
 */
const parseMimeType = (mimeType: string): MimeTypeDescriptor => {
    const [type = '', subtype = ''] = mimeType.split('/');
    return {
        type,
        subtype,
        subtypeTokens: subtype.split('+'),
    };
};

type MimeTypePredicate = (mimeType: string) => boolean;

// This factory creates a predicate function that checks a string mime-type against defined rules.
const mimeTypePredicateFactory = (predicate: (descriptor: MimeTypeDescriptor) => boolean): MimeTypePredicate => (mimeType) => predicate(parseMimeType(mimeType));

// Use this factory when you need to define a simple predicate based only on type and, if applicable, subtype.
const mimeTypeSimplePredicateFactory = (type: string, subtype?: string): MimeTypePredicate => mimeTypePredicateFactory((descriptor) => {
    if (descriptor.type !== type) return false;
    if (subtype != null && descriptor.subtype !== subtype) return false;
    return true;
});

// Creating a set of named predicates that will help us determine how to handle different mime-types
const isTextLikeMimeType = mimeTypeSimplePredicateFactory('text');
const isJsonMimeType = mimeTypeSimplePredicateFactory('application', 'json');
const isJsonLikeMimeType = mimeTypePredicateFactory((descriptor) => descriptor.type === 'application' && descriptor.subtypeTokens.some((item) => item === 'json'));
const isOctetStreamMimeType = mimeTypeSimplePredicateFactory('application', 'octet-stream');
const isFormUrlencodedMimeType = mimeTypeSimplePredicateFactory('application', 'x-www-form-urlencoded');

// Defining a list of mime-types in the order of prioritization for handling.
const supportedMimeTypePredicatesWithPriority: MimeTypePredicate[] = [
    isJsonMimeType,
    isJsonLikeMimeType,
    isTextLikeMimeType,
    isOctetStreamMimeType,
    isFormUrlencodedMimeType,
];

const nullableSuffix = " | null";
const optionalSuffix = " | undefined";
const arrayPrefix = "Array<";
const arraySuffix = ">";
const mapPrefix = "{ [key: string]: ";
const mapSuffix = "; }";

export class ObjectSerializer {
    public static findCorrectType(data: any, expectedType: string) {
        if (data == undefined) {
            return expectedType;
        } else if (primitives.indexOf(expectedType.toLowerCase()) !== -1) {
            return expectedType;
        } else if (expectedType === "Date") {
            return expectedType;
        } else {
            if (enumsMap.has(expectedType)) {
                return expectedType;
            }

            if (!typeMap[expectedType]) {
                return expectedType; // w/e we don't know the type
            }

            // Check the discriminator
            let discriminatorProperty = typeMap[expectedType].discriminator;
            if (discriminatorProperty == null) {
                return expectedType; // the type does not have a discriminator. use it.
            } else {
                if (data[discriminatorProperty]) {
                    var discriminatorType = data[discriminatorProperty];
                    let mapping = typeMap[expectedType].mapping;
                    if (mapping != undefined && mapping[discriminatorType]) {
                        return mapping[discriminatorType]; // use the type given in the discriminator
                    } else if(typeMap[discriminatorType]) {
                        return discriminatorType;
                    } else {
                        return expectedType; // discriminator did not map to a type
                    }
                } else {
                    return expectedType; // discriminator was not present (or an empty string)
                }
            }
        }
    }

    public static serialize(data: any, type: string, format: string): any {
        if (data == undefined) {
            return data;
        } else if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        } else if (type.endsWith(nullableSuffix)) {
            let subType: string = type.slice(0, -nullableSuffix.length); // Type | null => Type
            return ObjectSerializer.serialize(data, subType, format);
        } else if (type.endsWith(optionalSuffix)) {
            let subType: string = type.slice(0, -optionalSuffix.length); // Type | undefined => Type
            return ObjectSerializer.serialize(data, subType, format);
        } else if (type.startsWith(arrayPrefix)) {
            let subType: string = type.slice(arrayPrefix.length, -arraySuffix.length); // Array<Type> => Type
            let transformedData: any[] = [];
            for (let date of data) {
                transformedData.push(ObjectSerializer.serialize(date, subType, format));
            }
            return transformedData;
        } else if (type.startsWith(mapPrefix)) {
            let subType: string = type.slice(mapPrefix.length, -mapSuffix.length); // { [key: string]: Type; } => Type
            let transformedData: { [key: string]: any } = {};
            for (let key in data) {
                transformedData[key] = ObjectSerializer.serialize(
                    data[key],
                    subType,
                    format,
                );
            }
            return transformedData;
        } else if (type === "Date") {
            if (format == "date") {
                let month = data.getMonth()+1
                month = month < 10 ? "0" + month.toString() : month.toString()
                let day = data.getDate();
                day = day < 10 ? "0" + day.toString() : day.toString();

                return data.getFullYear() + "-" + month + "-" + day;
            } else {
                return data.toISOString();
            }
        } else {
            if (enumsMap.has(type)) {
                return data;
            }
            if (!typeMap[type]) { // in case we dont know the type
                return data;
            }

            // Get the actual type of this object
            type = this.findCorrectType(data, type);

            // get the map for the correct type.
            let attributeTypes = typeMap[type].getAttributeTypeMap();
            let instance: {[index: string]: any} = {};
            for (let attributeType of attributeTypes) {
                instance[attributeType.baseName] = ObjectSerializer.serialize(data[attributeType.name], attributeType.type, attributeType.format);
            }
            return instance;
        }
    }

    public static deserialize(data: any, type: string, format: string): any {
        // polymorphism may change the actual type.
        type = ObjectSerializer.findCorrectType(data, type);
        if (data == undefined) {
            return data;
        } else if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        } else if (type.endsWith(nullableSuffix)) {
            let subType: string = type.slice(0, -nullableSuffix.length); // Type | null => Type
            return ObjectSerializer.deserialize(data, subType, format);
        } else if (type.endsWith(optionalSuffix)) {
            let subType: string = type.slice(0, -optionalSuffix.length); // Type | undefined => Type
            return ObjectSerializer.deserialize(data, subType, format);
        } else if (type.startsWith(arrayPrefix)) {
            let subType: string = type.slice(arrayPrefix.length, -arraySuffix.length); // Array<Type> => Type
            let transformedData: any[] = [];
            for (let date of data) {
                transformedData.push(ObjectSerializer.deserialize(date, subType, format));
            }
            return transformedData;
        } else if (type.startsWith(mapPrefix)) {
            let subType: string = type.slice(mapPrefix.length, -mapSuffix.length); // { [key: string]: Type; } => Type
            let transformedData: { [key: string]: any } = {};
            for (let key in data) {
                transformedData[key] = ObjectSerializer.deserialize(
                    data[key],
                    subType,
                    format,
                );
            }
            return transformedData;
        } else if (type === "Date") {
            return new Date(data);
        } else {
            if (enumsMap.has(type)) {// is Enum
                return data;
            }

            if (!typeMap[type]) { // dont know the type
                return data;
            }
            let instance = new typeMap[type]();
            let attributeTypes = typeMap[type].getAttributeTypeMap();
            for (let attributeType of attributeTypes) {
                let value = ObjectSerializer.deserialize(data[attributeType.baseName], attributeType.type, attributeType.format);
                if (value !== undefined) {
                    instance[attributeType.name] = value;
                }
            }
            return instance;
        }
    }


    /**
     * Normalize media type
     *
     * We currently do not handle any media types attributes, i.e. anything
     * after a semicolon. All content is assumed to be UTF-8 compatible.
     */
    public static normalizeMediaType(mediaType: string | undefined): string | undefined {
        if (mediaType === undefined) {
            return undefined;
        }
        return (mediaType.split(";")[0] ?? '').trim().toLowerCase();
    }

    /**
     * From a list of possible media types, choose the one we can handle best.
     *
     * The order of the given media types does not have any impact on the choice
     * made.
     */
    public static getPreferredMediaType(mediaTypes: Array<string>): string {
        /** According to OAS 3 we should default to json */
        if (mediaTypes.length === 0) {
            return "application/json";
        }

        const normalMediaTypes = mediaTypes.map(ObjectSerializer.normalizeMediaType);

        for (const predicate of supportedMimeTypePredicatesWithPriority) {
            for (const mediaType of normalMediaTypes) {
                if (mediaType != null && predicate(mediaType)) {
                    return mediaType;
                }
            }
        }

        throw new Error("None of the given media types are supported: " + mediaTypes.join(", "));
    }

    /**
     * Convert data to a string according the given media type
     */
    public static stringify(data: any, mediaType: string): string {
        if (isTextLikeMimeType(mediaType)) {
            return String(data);
        }

        if (isJsonLikeMimeType(mediaType)) {
            return JSON.stringify(data);
        }

        throw new Error("The mediaType " + mediaType + " is not supported by ObjectSerializer.stringify.");
    }

    /**
     * Parse data from a string according to the given media type
     */
    public static parse(rawData: string, mediaType: string | undefined) {
        if (mediaType === undefined) {
            throw new Error("Cannot parse content. No Content-Type defined.");
        }

        if (isTextLikeMimeType(mediaType)) {
            return rawData;
        }

        if (isJsonLikeMimeType(mediaType)) {
            return JSON.parse(rawData);
        }

        throw new Error("The mediaType " + mediaType + " is not supported by ObjectSerializer.parse.");
    }
}
